import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/BlogSection/BlogSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/ForYou/ForYou.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/HomeSlider/HomeSlider.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/Seo/Seo.jsx");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/car.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/check-circle.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/check.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/favicon.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/kuryer.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/parfume.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/percent.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/refresh.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/images/candle.png");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/images/car.png");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/images/cat.png");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/images/coll.png");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/images/home.png");
